import { Component } from '@angular/core';
import { SidebarUiService } from '../sidebar/sidebar-ui.service';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  standalone: false,
})
export class PageHeaderComponent {
  constructor(public sidebarService: SidebarUiService) {}
}
